var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonorSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.5em",
    height: "1.25em",
    viewBox: "0 0 18 15",
    style: {
      enableBackground: "new 0 0 18 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,12.8H7.4v-1.5h0.8L4.4,8.4v1.4H2.9V8.3h1.4L1.4,6v8.3h10.7l-3.2-2.4V12.8z M4.4,12.8H2.9v-1.5h1.5V12.8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6,13.2l-2.7-2.1V6.8h-4.5V2.3L8.1,0L5.9,2.3v1.5H5.5L1.8,0.9C1.6,0.8,1.3,0.8,1.2,1L0.4,2 C0.2,2.2,0.3,2.5,0.5,2.6l15.8,12.3c0.2,0.1,0.5,0.1,0.6-0.1l0.8-1C17.8,13.6,17.8,13.3,17.6,13.2z M13.4,8.3v1.5h-0.2l-1.4-1.1 V8.3H13.4z M7.4,2.3h1.5v1.5H7.4V2.3z M8.9,5.3v1.1L7.4,5.3H8.9z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorSlash);
export default __webpack_public_path__ + "static/media/donor-slash.be3ce2b3e0e2706a7918b37643fa76c7.svg";
export { ForwardRef as ReactComponent };